import React from 'react';
import PropTypes from 'prop-types';

const MaintenanceComplianceScheduleModal = ({
  scheduleForm,
  lockedLastServiceFields,
  saveError,
  saveLoading,
  onClose,
  onSave,
  onFormChange,
}) => (
  <div className="maintenance-modal-overlay">
    <div
      className="maintenance-modal maintenance-compliance-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="maintenance-schedule-modal-title"
    >
      <div className="maintenance-modal-header">
        <h3 id="maintenance-schedule-modal-title" className="maintenance-modal-title">
          Edit service schedule
        </h3>
        <button
          type="button"
          className="maintenance-modal-close"
          aria-label="Close"
          onClick={onClose}
        >
          &times;
        </button>
      </div>
      <div className="maintenance-modal-body">
        <p className="maintenance-compliance-modal-desc">
          Configure last service and interval. Next service date and mileage are computed by the server.
        </p>
        <div className="maintenance-form-grid">
          <div className="maintenance-form-group">
            <label className="maintenance-form-label" htmlFor="lastServiceDate">Last service date</label>
            <input
              id="lastServiceDate"
              type="date"
              className={`maintenance-form-input${
                lockedLastServiceFields.lastServiceDate ? ' maintenance-form-input--readonly' : ''
              }`}
              value={scheduleForm.lastServiceDate}
              readOnly={lockedLastServiceFields.lastServiceDate}
              disabled={lockedLastServiceFields.lastServiceDate}
              onChange={(e) => onFormChange('lastServiceDate', e.target.value)}
            />
          </div>
          <div className="maintenance-form-group">
            <label className="maintenance-form-label" htmlFor="lastServiceOdometer">Last service mileage</label>
            <input
              id="lastServiceOdometer"
              type="number"
              className={`maintenance-form-input${
                lockedLastServiceFields.lastServiceOdometer ? ' maintenance-form-input--readonly' : ''
              }`}
              value={scheduleForm.lastServiceOdometer}
              readOnly={lockedLastServiceFields.lastServiceOdometer}
              disabled={lockedLastServiceFields.lastServiceOdometer}
              onChange={(e) => onFormChange('lastServiceOdometer', e.target.value)}
              placeholder="km"
            />
          </div>
          <div className="maintenance-form-group">
            <label className="maintenance-form-label" htmlFor="serviceIntervalKm">Service interval (km)</label>
            <input
              id="serviceIntervalKm"
              type="number"
              className="maintenance-form-input"
              value={scheduleForm.serviceIntervalKm}
              onChange={(e) => onFormChange('serviceIntervalKm', e.target.value)}
              placeholder="e.g. 5000"
            />
          </div>
          <div className="maintenance-form-group">
            <label className="maintenance-form-label" htmlFor="serviceIntervalMonths">Service interval (months)</label>
            <input
              id="serviceIntervalMonths"
              type="number"
              className="maintenance-form-input"
              value={scheduleForm.serviceIntervalMonths}
              onChange={(e) => onFormChange('serviceIntervalMonths', e.target.value)}
              placeholder="e.g. 6"
            />
          </div>
        </div>
        {saveError && <div className="maintenance-compliance-inline-error">{saveError}</div>}
      </div>
      <div className="maintenance-modal-footer">
        <button
          type="button"
          className="maintenance-modal-cancel"
          onClick={onClose}
          disabled={saveLoading}
        >
          Cancel
        </button>
        <button
          type="button"
          className="maintenance-modal-submit"
          onClick={onSave}
          disabled={saveLoading}
        >
          {saveLoading ? 'Saving…' : 'Save'}
        </button>
      </div>
    </div>
  </div>
);

MaintenanceComplianceScheduleModal.propTypes = {
  scheduleForm: PropTypes.shape({
    lastServiceDate: PropTypes.string,
    lastServiceOdometer: PropTypes.string,
    serviceIntervalKm: PropTypes.string,
    serviceIntervalMonths: PropTypes.string,
  }).isRequired,
  lockedLastServiceFields: PropTypes.shape({
    lastServiceDate: PropTypes.bool,
    lastServiceOdometer: PropTypes.bool,
  }).isRequired,
  saveError: PropTypes.string,
  saveLoading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onFormChange: PropTypes.func.isRequired,
};

MaintenanceComplianceScheduleModal.defaultProps = {
  saveError: '',
  saveLoading: false,
};

export default MaintenanceComplianceScheduleModal;
